import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TShipmentDetailsTableItem } from './types';

export const tableStructure: TTableStructure<
	keyof TShipmentDetailsTableItem,
	TShipmentDetailsTableItem
>[] = [
	{
		selector: 'name',
		name: '',
		show: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'original',
		name: 'Original',
		show: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.currency,
	},
	{
		selector: 'preliminary',
		name: 'Preliminary',
		show: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.currency,
	},
	{
		selector: 'actual',
		name: 'Actual',
		show: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item) => item.currency,
	},
	{
		selector: 'toBePaid',
		name: 'To Be Paid',
		show: true,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: () => 'EUR',
	},
];
